/*
 * @Author: Wang Wenmao
 * @Date: 2023-09-21 15:00:51
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-11-27 15:00:04
 * @Description: 商品参数展示配置
 */
import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: { displayLocation: { apiPath: '' } },
    components: {
        displayLocationView: {
            component: 'Card',
            title: '商品参数展示配置',
            entity: 'displayLocation',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [{ component: 'DisplayLocation' }],
            },
        },
        displayLocationInfoView: {
            component: 'Card',
            title: '编辑参数',
            entity: 'displayLocation',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [{ component: 'DisplayLocationInfo' }],
            },
        },
    },

    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/display-location',
                            breadcrumbName: '商品参数展示配置',
                            component: 'displayLocationView',
                        },
                        {
                            path: '/display-location-info/:id',
                            breadcrumbName: '编辑参数',
                            component: 'displayLocationInfoView',
                        },
                    ],
                },
            ],
        },
    ],
};
